import React from "react";

const Facilty = ({ title, content, icon }) => {
  return (
    <>
      <div className="flex gap-6  lg:w-[33.3%] w-full sm:py-2 pt-1 md:px-4 ">
        <p className="text-4xl md:text-6xl  text-[#469B8F] ">{icon}</p>
        <div className="">
        <span className="text-xl pt-2 font-bold font-roboto">{title}</span>
        <p className="text-justify pt-2 text-lg font-roboto">{content}</p>
        </div>
      </div>
    </>
  );
};

export default Facilty;
